export const popUpValues = [
  "-20.00",
  "-19.75",
  "-19.50",
  "-19.25",
  "-19.00",
  "-18.75",
  "-18.50",
  "-18.25",
  "-18.00",
  "-17.75",
  "-17.50",
  "-17.25",
  "-17.00",
  "-16.75",
  "-16.50",
  "-16.25",
  "-16.00",
  "-15.75",
  "-15.50",
  "-15.25",
  "-15.00",
  "-14.75",
  "-14.50",
  "-14.25",
  "-14.00",
  "-13.75",
  "-13.50",
  "-13.25",
  "-13.00",
  "-12.75",
  "-12.50",
  "-12.25",
  "-12.00",
  "-11.75",
  "-11.50",
  "-11.25",
  "-11.00",
  "-10.75",
  "-10.50",
  "-10.25",
  "-10.00",
  "-9.75",
  "-9.50",
  "-9.25",
  "-9.00",
  "-8.75",
  "-8.50",
  "-8.25",
  "-8.00",
  "-7.75",
  "-7.50",
  "-7.25",
  "-7.00",
  "-6.75",
  "-6.50",
  " -6.25",
  "-6.00",
  " -5.75",
  "-5.50",
  "-5.25",
  "-5.00",
  "-4.75",
  "-4.50",
  "-4.25",
  "-4.00",
  "-3.75",
  "-3.50",
  "-3.25",
  "-3.00",
  " -2.75",
  "-2.50",
  "-2.25",
  "-2.00",
  "-1.75",
  "-1.50",
  "-1.25",
  " -1.00",
  "-0.75",
  "-0.50",
  "-0.25",
  "0.00",
  "+0.25",
  "+0.50",
  "+0.75",
  "+1.00",
  "+1.25",
  "+1.50",
  "+1.75",
  "+2.00",
  "+2.25",
  "+2.50",
  "+2.75",
  "+3.00",
  "+3.25",
  "+3.50",
  "+3.75",
  "+4.00",
  " +4.25",
  "+4.50",
  "+4.75",
  "+5.00",
  "+5.25",
  "+5.50",
  "+5.75",
  "+6.00",
  "+6.25",
  "+6.50",
  "+6.75",
  "+7.00",
  " +7.25",
  "+7.50",
  "+7.75",
  "+8.00",
  "+8.25",
  "+8.50",
  "+8.75",
  "+9.00",
  "+9.25",
  "+9.50",
  " +9.75",
  "+10.00",
  "+10.25",
  "+10.50",
  "+10.75",
  "+11.00",
  "+11.25",
  "+11.50",
  "+11.75",
  "+12.00",
  "+12.25",
  "+12.50",
  "+12.75",
  " +13.00"
];
export const axisPopUpValue = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  64,
  65,
  66,
  67,
  68,
  69,
  70,
  71,
  72,
  73,
  74,
  75,
  76,
  77,
  78,
  79,
  80,
  81,
  82,
  83,
  84,
  85,
  86,
  87,
  88,
  89,
  90,
  91,
  92,
  93,
  94,
  95,
  96,
  97,
  98,
  99,
  100,
  102,
  103,
  104,
  105,
  106,
  107,
  108,
  109,
  110,
  112,
  113,
  114,
  115,
  116,
  117,
  118,
  119,
  120,
  121,
  123,
  124,
  125,
  126,
  127,
  128,
  129,
  130,
  131,
  132,
  133,
  134,
  135,
  136,
  137,
  138,
  139,
  140,
  141,
  142,
  143,
  144,
  145,
  146,
  147,
  148,
  149,
  150,
  151,
  152,
  153,
  154,
  155,
  156,
  157,
  158,
  159,
  160
];
export const birthYear = [
  "2021",
  "2020",
  "2019",
  "2018",
  "2017",
  "2016",
  "2015",
  "2014",
  "2013",
  "2012",
  "2011",
  "2010",
  "2009",
  "2008",
  "2007",
  "2006",
  "2005",
  "2004",
  "2003",
  "2002",
  "2001",
  "2000",
  "1999",
  "1998",
  "1997",
  "1996",
  "1995",
  "1994",
  "1993",
  "1992",
  "1991",
  "1990",
  "1989",
  "1988",
  "1987",
  "1986",
  "1985",
  "1984",
  "1983",
  "1982",
  "1981",
  "1980",
  "1979",
  "1978",
  "1977",
  "1976",
  "1975",
  "1974",
  "1973",
  "1972",
  "1971",
  "1970",
  "1969",
  "1968",
  "1967",
  "1966",
  "1965",
  "1964",
  "1963",
  "1962",
  "1961",
  "1960",
  "1959",
  "1958",
  "1957",
  "1956",
  "1955",
  "1954",
  "1953",
  "1952",
  "1951",
  "1950",
  "1913",
  "1912",
  "1911"
];
export const pupilaryDistance = [
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  64,
  65,
  66,
  67,
  68,
  69,
  70,
  71,
  72,
  73,
  74,
  75,
  76,
  77,
  78,
  79,
  80
];
export const leftRight = [
  "17.5",
  "18.0",
  "18.5",
  "19.0",
  "19.5",
  "20.0",
  "20.5",
  " 21.0",
  "21.5",
  "22.0",
  "22.5",
  "23.0",
  "23.5",
  "24.0",
  "24.5",
  "25.0",
  "25.5",
  "26.0",
  "26.5",
  "27.0",
  "27.5",
  "28.0",
  "28.5",
  "29.0",
  "29.5",
  "30.0",
  "30.5",
  "31.0",
  "31.5",
  "32.0",
  "32.5",
  "33.0",
  "33.5",
  "34.0",
  "34.5",
  "35.0",
  "35.5",
  "36.0",
  "36.5",
  "37.0",
  "37.5",
  "38.0",
  "38.5",
  "39.0",
  "39.5",
  "40.0"
];
